import {Modal} from '@/utils/escapeAntd';
import ErrorContent from '@/components/ErrorBoundary/ErrorContent';
import {QualifyQueryParams} from '@/types/params';
import {getRedirectParams} from '@/modules/List/components/urlParamsUtil';
import client from '@/api/client';
import {QualifyInfo} from '@/types/api/qualify';
import {USER_CENTER} from '@/dicts/qualify';
import {getParamStr, getTicketUrl, isLoadByIframe, openInSamePage} from './util';
import {isVirtualUser} from './vcp';

export function globalError(error: any) {
    Modal.error({
        title: '温馨提示',
        autoFocusButton: null,
        content: (<ErrorContent message={error} />),
    });
}

export function getErrorMsg(error: any) {
    const message = error?.message || error || {};
    if (message?.detail?.message) {
        return message?.detail?.message;
    }
    return message?.global ? message?.global : '系统错误';
}

function getErrorFromMessage(message: any) {
    if (message?.detail?.message) {
        return message?.detail?.message;
    }
    return message.global ? message.global : '系统错误';
}

export function showErrorDialogInfo(message: any, module: string, config: any) {
    Modal.error({
        title: config.title || '提示',
        okText: config.okText || '确定',
        autoFocusButton: null,
        onOk: config.onOk ? () => config.onOk({message, module}) : () => null,
        onCancel: config.onCancel ? () => config.onCancel({message, module}) : () => null,
        content: getErrorFromMessage(message),
    });
}

export function errorHandler(
    message: any,
    module: string,
    config: any,
    display?: (message: any, module: string, config: any) => void
) {
    if (message?.detail) {
        const {detail} = message || {};
        if (detail.code) {
            return display
                ? display(message, module, config || {})
                : showErrorDialogInfo(message, module, config || {});
        }
    }
    globalError(message);
}

// 企业认证提交报错通用处理
export function companySubmitErrorHandler(
    error: any,
    query?: QualifyQueryParams,
    info?: QualifyInfo,
    callback?: () => void
) {
    let okText = '确定';
    const message = error?.message;
    if (message?.detail?.code === 'AUTH_REACH_LIMIT') {
        okText = '返回';
    }
    if (message?.detail?.code === 'PRIMARY_CORPORATION_NAME_CHANGE_IN_PROCESS') {
        okText = '撤回';
    }
    if (message?.detail?.code === 'CORPORATION_NAME_MATCH_RISK') {
        message.detail.message = info?.hasPassCorporationPrime ? '您的账号异常，请提交工单咨询' : '您的主体暂不支持企业认证，请您完成个人认证';
        okText = info?.hasPassCorporationPrime ? '提交工单' : '前往个人认证';
    }
    return errorHandler(message, 'qualify', {
        title: '提示',
        okText,
        // eslint-disable-next-line complexity
        onOk: ({message}: any) => {
            const {detail} = message;
            if (detail.code === 'AUTH_REACH_LIMIT') {
                sessionStorage.removeItem('reject_sync');
                const params = getRedirectParams(query);
                const url = isLoadByIframe() ? '#/qualify/index' : '#/qualify/choices/company';
                openInSamePage(getParamStr(url, params));
                return;
            }
            if (detail.code === 'ID_CARD_REACHED_MAX_LIMIT') {
                location.href = USER_CENTER;
                return;
            }
            // 当前认证不可用，尝试其他认证方式
            if (detail.code === 'SERVICE_IS_NOT_AVAILABLE') {
                const params = getRedirectParams(query);
                openInSamePage(getParamStr('#/qualify/index', params));
                return;
            }
            if (detail.code === 'PRIMARY_CORPORATION_NAME_CHANGE_IN_PROCESS') {
                return client.drawbackChange();
            }
            if (detail.code === 'CORPORATION_NAME_MATCH_RISK' && !info?.hasPassCorporationPrime) {
                const params = getRedirectParams(query);
                const url = isLoadByIframe() ? '#/qualify/index' : '#/qualify/choices/person';
                openInSamePage(getParamStr(url, params));
                return;
            }
            if (detail.code === 'CORPORATION_NAME_MATCH_RISK' && info?.hasPassCorporationPrime) {
                location.href = getTicketUrl();
                return;
            }
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
    });
}

// 个人认证提交报错通用处理
export function personSubmitErrorHandler(
    result: any,
    query?: QualifyQueryParams,
    callback?: () => void
) {
    let okText = '确定';
    const error = result.message;
    if (error.detail && error.detail.code && error.detail.code === 'AUTH_REACH_LIMIT') {
        okText = '返回';
    }
    return errorHandler(error, 'qualify', {
        title: '提示',
        okText,
        onOk: ({message}: any) => {
            const {detail} = message;
            if (detail.code === 'AUTH_REACH_LIMIT') {
                sessionStorage.removeItem('reject_sync');
                const params = getRedirectParams(query);
                const url = isLoadByIframe() ? '#/qualify/index' : '#/qualify/choices/person';
                openInSamePage(getParamStr(url, params));
                return;
            }
            if (detail.code === 'ID_CARD_REACHED_MAX_LIMIT') {
                if (isVirtualUser()) {
                    callback?.();
                    return;
                }
                location.href = USER_CENTER;
                return;
            }
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
    });
}
